import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",
        flexFlow: "row-wrap",
        padding:0,
    },

    gridList: {
        width: '100%',
        position: 'relative',
        overflow: 'auto',
        // maxHeight: 570,
    },     

    rootLista: {
        width: '100%',
        maxWidth: '100%',
    }, 

    colorIcon:{
        color: 'black',
    },

    colorChip:{
        backgroundColor: '#1C4E78',
        color:'white'
    },

    colorChipEmpty:{
        backgroundColor: '#ff4e4e',
        color:'white'
    },

    icon: {
        color: "#fff"
    },

    bounceShake: {
        color: "#fff",
        animation: `$bounceShake 1s ease-in-out infinite`,
        display: "inline-block",
    },

    "@keyframes bounceShake": {
        "0%": {
        transform: "scale(1) translateX(0)",
        },
        "20%": {
        transform: "scale(1.08) translateX(-2px)",
        },
        "40%": {
        transform: "scale(0.95) translateX(2px)",
        },
        "60%": {
        transform: "scale(1.05) translateX(-1px)",
        },
        "80%": {
        transform: "scale(1) translateX(1px)",
        },
        "100%": {
        transform: "scale(1) translateX(0)",
        },
    },
}))